import axios from 'axios'

axios.interceptors.request.use(function (config) {
  config.headers.Authorization = localStorage.getItem('jwt-token')

  return config
})

export const apiRequest = (method, endpoint, data, headers, params) => {
  return axios({
    method,
    url: endpoint,
    data,
    headers,
    params
  })
  .then(response => {
    if(response.data?.errors) {
      console.error('Query error', 'Request:', method, endpoint, data, '\nResponse: ',response.data.data, response.data.errors)
    }
    return response.data
  })
  .catch(error => {
    console.error(error)
    if (error.response) {
      if (error.response.status === 401) {
        window.location.assign('/api/auth/login?redirectPath=' + window.location.pathname)
      } else if (error.response.status >= 500) {
        window.location.replace('/beneficiary/error/' + error.response.status)
      } else if (error.response.status === 403) {
        if(error.response.data === 'cgu.approval') {
          window.location.replace('/beneficiary/cgu')
        } else {
          window.location.replace('/beneficiary/error/' + error.response.status)
        }
      } else {
        console.error(error)
        window.location.replace('/beneficiary/error/520')
      }
    }
  })
}

export const graphqlRequest = (query) => {
  return apiRequest('POST', '/api/beneficiary/graphql/v1', { query })
}

export const getContactReference = () => {
  return apiRequest('GET', '/api/beneficiary/rest/v1/contactReference')
}

export const getFaqs = () => {
  return apiRequest('GET', '/api/beneficiary/rest/v1/faqs')
}

export const getEmployee = (employeeFields) => {
  return graphqlRequest(`
  {
    getEmployee {
      ${ employeeFields }
    }
  }
  `)
}

export const updateEmployeeQuery = (employeeInput, employeeFields) => {
  return graphqlRequest(`
    mutation {
      updateEmployee(employeeInput: {
        ${ employeeInput }
      }){
        ${ employeeFields }
      }
    }
  `)
}

export const checkSimulation = (simulation, simulationOnly) => {
  return graphqlRequest(`
  {
    benefitSimulation(benefitSimulationInput: {
      ${ simulation.singleParent ? 'singleParent: true' : '' }
      ${ simulation.childSupport ? `childSupportAnnualAmount:${ simulation.childSupport }` : '' }
      ${ (simulation.partnerIncome || simulation.partnerIncome === 0) ? `partnerAnnualNetIncome: ${ simulation.partnerIncome }` : '' }
      ${ simulation.nbChildren ? `nbChildren: ${ simulation.nbChildren }` : '' }
    }
    simulationOnly: ${ simulationOnly }) {
      eligible
    }
  }`)
}

export const checkJwt = () => {
  return apiRequest('GET', '/api/auth/check')
}

export const getCgu = () => {
  return apiRequest('GET', '/api/beneficiary/rest/v1/cgu')
}

export const getConsentLabel = (labelKey) => {
  return apiRequest('GET', '/api/beneficiary/rest/v1/consentLabel', {}, {}, { key: labelKey })
}

export const getConsentLabels = (labelKeys) => {
  return apiRequest('POST', '/api/beneficiary/rest/v1/consentLabels', { keys: labelKeys })
}

export const approveCgu = () => {
  return graphqlRequest(`
    mutation {
      approveCgu
    }
  `)
}

export const getNotifications = () => {
  return graphqlRequest(`
  {
    getNotifications {
      _id
      createdDate
      childName
      babysittingMode
      title
    }
  }
  `)
}

export const getNotificationDetail = (_id) => {
  return graphqlRequest(`
  {
    getNotification(_id: "${ _id }") {
      _id
      createdDate
      childName
      babysittingMode
      title
      message
    }
  }
  `)
}


export const deleteNotification = (_id) => {
  return graphqlRequest(`
  mutation {
    deleteNotification(_id: "${ _id }")
  }
  `)
}

export const sendContactMessage = (contactMessage) => {
  return graphqlRequest(`
  mutation {
    sendContactMessage(contactMessage: {` + Object.keys(contactMessage).map(key => `${ key }: "${ contactMessage[key] }"`).join(' ') + `})
  }
  `)
}

export function getConsentReapprovedMessage() {
  return apiRequest('GET', '/api/beneficiary/rest/v1/consentReapprovedMessage')
}

export const approveConsent = () => {
  return graphqlRequest(`
    mutation {
      approveConsent
    }
  `)
}

export function incrementConnection() {
  return graphqlRequest(`
    mutation {
      connectionStatistic
    }
  `)
}

export function incrementStatistic(type, key) {
  return graphqlRequest(`
    mutation {
      incrementStatistic(
        type: ${ type }
        ${ key ? `key: "${ key }"` : ''}
      )
    }
  `)
}

export function getInitConfig() {
  return apiRequest('GET', '/api/beneficiary/rest/v1/init-config')
}
